import actions from './actions';

const { GET_HOURLY_REPORT_LOAD, GET_HOURLY_REPORT_SUCCESS, GET_HOURLY_REPORT_ERROR } = actions;

const initialState = {
  hourlyStatus: [],
  totalIdleTime: 0,
  totalrunTime: 0,
  loading: false,
  error: null,
};

const hourlyStatusReducer = (state = initialState, action) => {
  const { type, hourReport, err } = action;

  switch (type) {
    case GET_HOURLY_REPORT_LOAD:
      return { ...state, hourlyStatus: [], loading: true };

    case GET_HOURLY_REPORT_SUCCESS:
      if (hourReport.data === undefined) return;

      return {
        ...state,
        hourlyStatus: hourReport.data !== undefined && hourReport.data,
        totalIdleTime: hourReport.totalIdleTime,
        totalrunTime: hourReport.totalrunTime,
        error: false,
        loading: false,
      };

    case GET_HOURLY_REPORT_ERROR:
      return { ...state, totalIdleTime: 0, totalrunTime: 0, error: err, loading: false };

    default:
      return state;
  }
};

export { hourlyStatusReducer };
